import { DateTime } from 'luxon';
import { WO_STATUS } from '../utils/constants';
import { isCourtesyRideInProgress } from '../utils/LyftRide';

const workOrdersByDay = (workOrders, timezone, day) => {
  const targetDate = day === 'today' 
    ? DateTime.now().setZone(timezone).startOf('day').toFormat('yyyy-MM-dd')
    : DateTime.now().setZone(timezone).minus({ days: 1 }).startOf('day').toFormat('yyyy-MM-dd');

  return workOrders?.filter(wo => {
    const expectedDateTime = wo.frontend_display_date || wo.customer_eta

    if (!expectedDateTime) return false;
    if (wo.cf_order_status === "X") return false;
    if (wo.customer_status === 'Service Call') return false;

    const momentWO = DateTime.fromISO(expectedDateTime).setZone(timezone).startOf('day').toFormat('yyyy-MM-dd');
    return DateTime.fromISO(momentWO).equals(DateTime.fromISO(targetDate));
  });
};

const checkWOsData = (currentWOs, WOToPush) => {
  const WOExists = currentWOs.findIndex(wo => wo.WO === WOToPush.WO);
  if(WOExists !== -1) {
    let WOsUpdated = [...currentWOs];
    WOToPush.SmsData = WOsUpdated[WOExists].SmsData;
    WOsUpdated[WOExists] = WOToPush;
    return WOsUpdated;
  }
  return [...currentWOs, WOToPush]
}

const updateCourtesyRidesData = (currentWOs, WOId, courtesyRide) => {
  const WOIndex = currentWOs.findIndex(wo => wo.WO === WOId);
  let WOsUpdated = [...currentWOs];

  if (WOIndex !== -1) {
    let WOToUpdate = { ...WOsUpdated[WOIndex] };
    if(!WOToUpdate?.CourtesyRidesData) {
      WOToUpdate.CourtesyRidesData = []
    }
    WOToUpdate.CourtesyRidesData[0] = courtesyRide;
    WOsUpdated[WOIndex] = WOToUpdate;
  }

  return WOsUpdated;
};

const getRandomTime = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

const getWOsByStatus = (workOrders) => {
  return workOrders?.filter(wo => wo.cf_order_status === "N" || wo.cf_order_status === "O").length;
}

const parseNumberAndStreetFromWO = (address) => {
  if (address !== '' && address !== null) {
    const number = address.substring(0, address.indexOf(' '));
    const street = address.substring(address.indexOf(' ') + 1);
    return { number, street };
  } else return { number: '', street: '' };
}

const removeWOs = (WOs, timeZone, isCourtesyRidesEnabled) => {
  const currentTime = DateTime.now().toUTC().setZone(timeZone);
  const filteredWOs = WOs.filter(WO => {
    const lastModifiedTime = DateTime.fromISO(WO.last_modified_date).toUTC().setZone(timeZone);
    const diffInHours = currentTime.diff(lastModifiedTime, 'hours').hours;
    return !(
      WO.Status === WO_STATUS.Tendered && 
      (WO?.SmsData && WO.SmsData.vehicleReadyMessage.length !== 0) && 
      diffInHours > 1 &&
      !isCourtesyRideInProgress(WO, isCourtesyRidesEnabled)
    );
  });

  return filteredWOs;
}

export { 
  workOrdersByDay,
  checkWOsData,
  getRandomTime,
  getWOsByStatus,
  parseNumberAndStreetFromWO,
  updateCourtesyRidesData,
  removeWOs
}